import { CompaniesResponse } from "./companies";

export class Settings {
  computer_error_timeout: number = 1;
  play_time_after_balance_zero: number = 5;
  momo_config: Record<string, any> = {};
  food_order_payment_type: number = 2;
  food_payment_methods: Record<string, any> = {};
  deposit_wallet_type: number = 1;
  play_time_wallet_type: number = 1;

  constructor(data?: Partial<Settings>) {
    Object.assign(this, data);
  }
}

export class BrandResponse {
  _id: string = "";
  created_at: string = "";
  updated_at: string = "";
  status: number = 0;
  normalized_value: string = "";
  identifier_name: string = "";
  logo: string = "";
  banner: string = "";
  name: string = "";
  phone: string = "";
  description: string = "";
  street: string = "";
  ward: Location = new Location();
  district: Location = new Location();
  city: Location = new Location();
  website: string = "";
  facebook_url: string = "";
  zalo_url: string = "";
  settings: Settings = new Settings();
  company: CompaniesResponse = new CompaniesResponse();

  constructor(data?: Partial<BrandResponse>) {
    Object.assign(this, data);
  }
}

export class Location {
  code: string = "";
  name: string = "";
  full_name: string = "";
  normalized_value: string = "";

  constructor(data?: Partial<Location>) {
    Object.assign(this, data);
  }
}

export class DetailBrandResponse {
  _id: string = "";
  created_at: string = "";
  updated_at: string = "";
  brand_id: string = "";
  department_id: string = "";
  status: number = 0;
  name: string = "";
  birthday: string = "";
  joining_date: string = "";
  gender: number = 0;
  avatar: string = "";
  phone: string = "";
  address: string = "";
  id_card_number: string = "";
  username: string = "";
  totp_secret: string = "";
  totp_qr_code: string = "";
  is_owner: number = 0;
  identifier_name: string = "";
  brand_name: string = "";
  password: string = "";
  company: CompaniesResponse = new CompaniesResponse();

  constructor(data?: Partial<DetailBrandResponse>) {
    Object.assign(this, data);
  }
}
